
import SlickSlider from '../SlickSlider';
/**
 * Component: Gallery Stack
 */

export default class GalleryStack {
    constructor() {
        this.selectors = {
            icons: '.data-gallery-stack-icons',
            icon: 'data-gallery-stack-icon',
            image: 'gallery-stack__image',
            npi_images: '[data-npi-images]'
        };

        this.$iconArr = $('[' + this.selectors.icon + ']');
        this.$imageArr = $('.' + this.selectors.image);
        this.$npiArr = $(this.selectors.npi_images);

        this.sliderSettings = {
            initialSlide: 1,
            mobileFirst: true,
            infinite: false,
            arrows: false,
            centerMode: true,
            rows: 0,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        };

        this.init();
    }

    initSlickSlider() {
        this.$icons.slick(this.sliderSettings);
    }

    createNPISlider() {
        const config = {
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            fade: false,
            dots: false,
            rows: 0,
            slidesToScroll: 1,
            variableWidth: false

        };

        return new SlickSlider(this.$npiArr, config);
    }

    updateActive($elementsArr = [], index = 0) {
        if (!$elementsArr.length) return;

        $elementsArr.removeClass('active');
        if ($elementsArr[index]) {
            $elementsArr[index].classList.add('active');
        }

        this.$npiArr.slick('slickGoTo', index);
    }

    onWindowResize() {
        $(window).on('resize', () => {
            if (!this.$icons.length) return;

            // re-intialize slick if on mobile

            if ($(window).width() < 767 && !this.$icons.hasClass('slick-initialized')) {
                this.$icons.slick(this.sliderSettings);
            }
        });
    }

    onSliderChange() {
        this.$icons.on('afterChange', (event, slick, currentSlide) => {
            this.updateActive(this.$iconArr, currentSlide);
            this.updateActive(this.$imageArr, currentSlide);
        });
    }

    onSliderInit() {
        this.$icons.on('init', () => {
            var slickCurrentIndex = this.$icons
                .find('.slick-current')
                .attr('data-slick-index');

            this.updateActive(this.$iconArr, slickCurrentIndex);
            this.updateActive(this.$imageArr, slickCurrentIndex);
        });
    }

    onIconClick() {
        $('.gallery-stack__icons').on('click', 'button', (e) => {
            var index = $(e.currentTarget)
                .attr('data-gallery-stack-index');

            this.updateActive(this.$iconArr, index);
            this.updateActive(this.$imageArr, index);
            this.updateActive(this.$npiArr, index);
        });
    }

    bindEvents() {
        this.onWindowResize();
        this.onSliderChange();
        this.onSliderInit();
        this.onIconClick();
    }

    init() {
        this.$icons = $(this.selectors.icons);

        this.createNPISlider();
        this.bindEvents();
        this.initSlickSlider();
    }
}
